import { useEffect, useRef, useState } from 'react';

const chapters = [
  {
    num: '01',
    title: '私たちの治療に対する考え方',
    sub: '最初に「判断軸」を示します。',
    body: `私たちが大切にしているのは
治療を決断する前に
医学的な根拠に基づいた「判断軸」を示すことです。
「ブランド名」や「価格の安さ」ではない「判断軸」を提供することが私たちの大切な役割と考えています。`,
    href: '#chapter1',
  },
  {
    num: '02',
    title: '判断整理レポートとは何か',
    sub: 'なぜ「説明」ではなく「整理」なのか',
    body: `迷いの原因は、情報不足ではありません
判断軸を整理するための資料です
決断を迫るためのものではありません`,
    href: '#chapter2',
  },
  {
    num: '03',
    title: '向き・不向きが生まれる理由',
    sub: '努力では埋まらない差が、どこにあるのか',
    body: `向き不向きは、努力や性格の問題ではありません
歯や骨格の構造で決まります
判断の分かれ目を共有します`,
    href: '#chapter3',
  },
  {
    num: '04',
    title: 'いつ始めるか、という視点',
    sub: '今と10年後では、前提がどう変わるのか',
    body: `矯正は、時間とともに前提が変わる治療です
今やるかどうかに正解はありません
今どう判断するかが大切です`,
    href: '#chapter5',
  },
  {
    num: '05',
    title: '費用はどう決まるのか',
    sub: '今と10年後では、前提がどう変わるのか',
    body: `費用は装置ではなく、治療量で決まります
診断後に、過不足のないプランを選びます
構造としてご説明します`,
    href: '#chapter6',
  },
  {
    num: '06',
    title: 'よくある質問',
    sub: '判断前に、よく出てくる疑問について',
    body: `その場で決めない前提のQ&Aです
判断のために、事前に知っておいてください
他院比較の材料としても使えます`,
    href: '#chapter8',
  },
];

export default function PhilosophyToc() {
  const sectionRef = useRef<HTMLElement>(null);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up-item').forEach((el) => el.classList.add('visible'));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-16 px-6 bg-gray-50">
      <div className="max-w-4xl mx-auto space-y-4">
        {chapters.map((ch, i) => (
          <div key={i} className="bg-white rounded-lg overflow-hidden fade-up-item">
            <button
              className="w-full px-6 py-5 flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
            >
              <div className="flex-1 text-left">
                <div className="flex items-start gap-4">
                  <span className="text-2xl font-bold flex-shrink-0" style={{ color: '#3E5F8F' }}>{ch.num}</span>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-gray-900 mb-1" style={{ fontFamily: 'Noto Serif JP, serif' }}>{ch.title}</h3>
                    <p className="text-sm text-gray-600">{ch.sub}</p>
                  </div>
                </div>
              </div>
              <i className={`ri-add-line text-2xl text-gray-400 transition-transform duration-300 flex-shrink-0 ml-4 ${openIndex === i ? 'rotate-45' : ''}`} />
            </button>
            <div
              className="overflow-hidden"
              style={{
                maxHeight: openIndex === i ? '300px' : '0',
                opacity: openIndex === i ? 1 : 0,
                transition: 'max-height 0.4s ease, opacity 0.3s ease',
              }}
            >
              <div className="px-6 pb-6 pt-2">
                <p className="text-sm text-gray-700 whitespace-pre-line mb-4">{ch.body}</p>
                <a
                  href={ch.href}
                  className="text-sm font-medium inline-flex items-center whitespace-nowrap hover:opacity-70"
                  style={{ color: '#3E5F8F' }}
                >
                  この章を読む →
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}